import { useQuery } from "@apollo/client";

import { FLOWS_PROJECTS } from "./gql";

const useFlowsProjects = () => {
  const { data, loading, error } = useQuery(FLOWS_PROJECTS);

  return {
    projects: data?.flowsProjects ?? [],
    loading,
    error,
  };
};

export default useFlowsProjects;
